<template>
<div>
    <div class="ml-4 rounded  border pb-8 md:border-0 md:ml-0">
        <div class="w-4/5 m-auto pt-8 md:w-full">
            <p class="text-blue-700">Promo Codes</p>
            <p class="text-gray-500 text-sm ">Manage your Promo Codes</p>
            <div class="mt-10">
                <div class="flex text-sm md:text-xs">
                    <p class="text-blue-700 ">Ongoing Promo</p>
                    <p class="text-blue-700 ml-3 md:ml-1">Promo Code</p>
                    <p class="text-blue-700 ml-3 md:ml-1">Duration</p>
                </div>
                <div v-for="code in promoCodes" :key="code.id" class="flex">
                    <p class="border-2 rounded-lg p-3 md:p-1 md:ml-1 md:text-xs text-sm mt-3">{{code.discountPercentage}}% Discount</p>
                    <p class="border-2 rounded-lg p-3 md:p-1 md:ml-1 md:text-xs text-sm mt-3 ml-3">{{code.promoCode}} </p>
                    <p class="border-2 rounded-lg p-3 md:p-1 md:ml-1 md:text-xs text-sm mt-3 ml-3">{{code.duration}} Days</p>
                    <p><i @click="deletePromo(code)" class="fa fa-times mt-6 p-1 bg-gray-300 rounded-full ml-3"></i></p>
                </div>
            </div>
           

            <form @submit.prevent="updatePromo" class="mt-10 ">
                <p class="text-blue-700">Add Promo</p>
                <div class="flex mt-3 md:flex-col">
                    <div>
                         <input class="border-2 md:w-full rounded-lg p-2 text-sm" type="number" name="promo" id="promo" placeholder="Discount in % eg. 20" v-model="promo">
                        <p v-if="promoValidity === 'invalid'" class=" text-xs text-red-500">This field cannot be empty.</p>
                    </div>
                    <div>
                        <input class="border-2 x ml-2 md:w-full md:ml-0 md:mt-2 rounded-lg p-2 text-sm " type="text" name="promo" id="promo" placeholder="Promo Code eg. CarryGo20" v-model="promoCode">
                        <p v-if="promoCodeValidity === 'invalid'" class=" text-xs text-red-500">This field cannot be empty.</p>
                    </div>
                    <div>
                        <input class="border-2 ml-2 rounded-lg p-2 text-sm md:w-full md:ml-0 md:mt-2" type="number" name="promo" id="promo" placeholder="Duration in Days e.g 2" v-model="duration">
                        <p v-if="durationValidity === 'invalid'" class=" text-xs text-red-500">This field cannot be empty.</p>
                    </div>
                    
                    
                </div>
                
                <div class="mt-10 flex">
                    <button class="p-3 text-white rounded-lg" style="background-color:#0048AE">Update Promo</button>
                    <p v-if="isLoading" class="ml-2 mt-2 animate-spin rounded-full h-6 w-6 border border-t-2 border-b-2 border-blue-900 "></p>
                </div>
            </form>
        </div>
        
    </div>
    <SuccessfulModal
    v-show="successModal"
    @click="closeSuccessModal"
    :message="message"
    />
    <ErrorModal
    v-show="errorModal"
    @click="closeErrorModal"
    :message="message"
    />
</div>
</template>

<script>
import axios from 'axios';
import SuccessfulModal from '../../LandingPages/SuccessfulModal.vue';
import ErrorModal from '../ErrorModal.vue';
import {baseUrl} from '../../../Config';
const url = baseUrl;
export default {
    components: {
        SuccessfulModal,
        ErrorModal
    },
    data() {
        return {
            userId : localStorage.getItem('userId'),
            promoCodes: [],
            promo: "",
            promoCode: "",
            duration: "",
            promoValidity: "",
            promoCodeValidity: "",
            durationValidity: "",
            isLoading: false,
            errorModal: false,
            successModal: false,
            message: "",
            token : localStorage.getItem("token"),
            error: ""
        }
    },

    mounted() {
        this._getPromoCodes();
    },

    methods: {
        closeSuccessModal() {
            this.successModal = false;
            this._getPromoCodes()
        },
        closeErrorModal() {
            this.errorModal = false
        },
        _getPromoCodes() {
            axios({
                method: 'GET',
                url: `${url}/v1/web/users/config/promo/${this.userId}`,
                headers: {
                    'Content-type': 'application/json',
                    authorization: `Bearer ${this.token}`,
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                }
            })
            .then((res) => {
                this.promoCodes = res.data.data
            })
            .catch((err) => {
                let message = err.response.data.message;
                    if(err) {
                        this.errorModal = true;
                        this.message = message
                    }
                    this.isLoading = false;
            })
        },

        deletePromo(code) {
            axios({
                method: 'DELETE',
                url: `${url}/v1/web/users/config/promo/${code.promoCode}`,
                headers: {
                    'Content-type': 'application/json',
                    authorization: `Bearer ${this.token}`,
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                }
            })
            .then((res) => {
                res.json;
                
                this._getPromoCodes();
            })
            .catch((err) => {
                let message = err.response.data.message;
                    if(err) {
                        this.errorModal = true;
                        this.message = message
                    }
                    this.isLoading = false;
            })
        },

        updatePromo() {
            if(!this.promo) {
                this.promoValidity = 'invalid';
            } else if(!this.promoCode) {
                this.promoCodeValidity ='invalid';
            } else if(!this.duration) {
                this.durationValidity = 'invalid'
            } else {
                this.isLoading = true;
                axios({
                method: 'POST',
                url: `${url}/v1/web/users/config/promo/`,
                headers: {
                    'Content-type': 'application/json',
                    authorization: `Bearer ${this.token}`,
                    'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                },
                data: {
                    userId : this.userId,
                    discountPercentage: this.promo,
                    duration: this.duration,
                    promoCode: this.promoCode
                }
                })
                .then((res) =>{
                    this.isLoading = false;
                    this.successModal = true;
                    res.json;
                    this._getPromoCodes();
                })
                .catch((err) => {
                    let message = err.response.data.message;
                    if(err) {
                        this.errorModal = true;
                        this.message = message
                    }
                    this.isLoading = false;
                });
            }
        }
    }
}
</script>